<template>
  <div>
    <v-card elevation="0" height="2vh">
      <v-card-text>
        <v-row>
          <v-col class="icon-part">
            <v-icon class="main-icon mt-5" color="white">mdi-account</v-icon>
          </v-col>
          <v-col class="data-part">
            <v-row>
              <span class="mr-3 user-text">{{ user }}</span>
              <span class="mr-5 date-text">{{ date }}</span>
            </v-row>
            <v-row class="">
              <v-col cols="12" class="mt-1 note-part">
                <span class="note-text">{{ note }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  export default {
    props: {
      user: {
        type: String,
        require: true,
        default: '',
      },
      date: {
        type: String,
        require: true,
        default: '',
      },
      note: {
        type: String,
        require: true,
        default: '',
      },
    },
  };
</script>
<style scoped>
  .icon-part {
    width: 5% !important;
    min-width: 5% !important;
    max-width: 5% !important;
  }
  .data-part {
    width: 95% !important;
    min-width: 95% !important;
    max-width: 95% !important;
  }
  .main-icon {
    background: var(--dark-color);
    padding: 4px !important;
    border-radius: 50% !important;
  }
  .note-part {
    background: var(--background-color) !important;
    border-radius: 8px !important;
  }
  .user-text {
    font-size: 12px;
    color: #212121;
  }
  .date-text {
    font-size: 11px;
    color: #212121;
  }
  .user-text {
    font-size: 13px;
    font-weight: 600;
    color: #212121;
  }
  .date-text {
    font-size: 12px;
    font-weight: 400;
    color: #9e9e9e;
  }
  .note-text {
    font-size: 14px;
    font-weight: 500;
    color: #212121;
  }
</style>
